import * as React from 'react';
import { RowButton, TDSnapshot, useTldrawApp } from 'sn-wb-tldraw';

const isEmptyCanvasSelector = (s: TDSnapshot) => {
  return (
    s.appState.isEmptyCanvas &&
    Object.keys(s.document.pages[s.appState.currentPageId].shapes).length > 0
  );
};

export const BackToContent = React.memo(function BackToContent() {
  const app = useTldrawApp();

  const isEmptyCanvas = app.useStore(isEmptyCanvasSelector);

  if (!isEmptyCanvas) return null;

  return (
    <div
      className="absolute px-10 py-8 cursor-pointer"
      style={{
        bottom: '80px',
        right: '50%',
        transform: 'translate(50%, 0%)',
        boxShadow: ' 0px 2px 12px rgba(19, 23, 32, 0.08)',
        borderRadius: '8px',
        background: '#fff',
      }}
    >
      <div
        id="TD-Tools-Back_to_content"
        style={{
          pointerEvents: 'all',
          width: 'fit-content',
          minWidth: 0,
          gridRow: 1,
          flexGrow: 2,
          display: 'block',
          fontFamily: 'Graphik Web',
        }}
      >
        <span onClick={app.zoomToContent}>Back to content</span>
      </div>
    </div>
  );
});
